
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexcQMybPU3m1JcmQOsQeEZTDtXNU08ngOIFv4cJC5j6B4Meta } from "/builds/weplaybig/platform/big-front/pages/index.vue?macro=true";
import { default as loginy5H4Wj0vP9pLe7DRcxRgdAYPUcG5ykwMzSrsQRo2q74Meta } from "/builds/weplaybig/platform/big-front/pages/login.vue?macro=true";
import { default as indexkA7_45TYy_45YN_85CWaYf_45pqv5JXCsFWlvZFy_45s6_453SAlUMeta } from "/builds/weplaybig/platform/big-front/pages/admin/index.vue?macro=true";
import { default as indexLsxeUfA7CkyIR7UDMlL7kO8gzdQYbm9G_HTeYCjrh1cMeta } from "/builds/weplaybig/platform/big-front/pages/pass-d/index.vue?macro=true";
import { default as callbackZuvMkEzCAnpStBv3Z0LyhATX_454hnjyyPxGzgUZ8T2FAMeta } from "/builds/weplaybig/platform/big-front/pages/auth/callback.vue?macro=true";
import { default as _91slug_93Jjrh8fT8Hq9xtcB0_yEnQZCQ6WOKXo34r_bfAhzNuIwMeta } from "/builds/weplaybig/platform/big-front/pages/account/[slug].vue?macro=true";
import { default as indexiKHypc_45KgiYmcWw1WCKIRHKY3ndLpJXy8cGUxWXu7uMMeta } from "/builds/weplaybig/platform/big-front/pages/missions/index.vue?macro=true";
import { default as indexMPw94Af5816UbbNQlYSUgVUbr4wkxUaFCTCriJ_7E6IMeta } from "/builds/weplaybig/platform/big-front/pages/referral/index.vue?macro=true";
import { default as indexwm1C_2427G4dHk7ydnckeA_lo1TGlC3e7MnD77U91yAMeta } from "/builds/weplaybig/platform/big-front/pages/settings/index.vue?macro=true";
import { default as profile7CdQTi4f4qt_oyrOH_3nHbvOGaLzs4VIQ2PRhKr2V1QMeta } from "/builds/weplaybig/platform/big-front/pages/company/profile.vue?macro=true";
import { default as confidentialityIbNe916Feru5m7hSQstU7_Sc76E40HPX08ADyAsXYvUMeta } from "/builds/weplaybig/platform/big-front/pages/confidentiality.vue?macro=true";
import { default as indexrzRkNc_u2JldrTLbdKbJFEV0VftCFFXCDUZ_45GCUzhL4Meta } from "/builds/weplaybig/platform/big-front/pages/dashboard/index.vue?macro=true";
import { default as forgota9zvW7AMKqUF61ouZy_e1ergJn7I8oRNXvBuSWwWmLwMeta } from "/builds/weplaybig/platform/big-front/pages/password/forgot.vue?macro=true";
import { default as index12ROdBI2pTC7GqieTnMDBsrm23hZB2H_45iOSy9gRQs_45UMeta } from "/builds/weplaybig/platform/big-front/pages/subscribe/index.vue?macro=true";
import { default as indexAiR2IVJLIn_AJiq6QYRStdZhE_45v5OF1JsGnYQjF8gnMMeta } from "/builds/weplaybig/platform/big-front/pages/accounting/index.vue?macro=true";
import { default as mentions_45legalesZL0pDZ8xBVTmxPNN69ODUf5I5d7RcbOXsYiHZkucQCIMeta } from "/builds/weplaybig/platform/big-front/pages/mentions-legales.vue?macro=true";
import { default as editAVKpGr7L3i8mYPtPYI6VjZ7rol_NtnlOnZrILgYGBRAMeta } from "/builds/weplaybig/platform/big-front/pages/pass-d/[id]/edit.vue?macro=true";
import { default as joinAQ42WrDrCux8M_uE4q4lbV0mR9eeO_45tqPBYrvCnlCkcMeta } from "/builds/weplaybig/platform/big-front/pages/pass-d/[id]/join.vue?macro=true";
import { default as recoverWm_veIJxuKg7M_TVNu0dTudKRQjjxkYjmGc74SNCDggMeta } from "/builds/weplaybig/platform/big-front/pages/password/recover.vue?macro=true";
import { default as createRBjxEzLiGac5HDbsEzXYD6quRHFO_4516tCSoNcmYmVuMMeta } from "/builds/weplaybig/platform/big-front/pages/accounting/create.vue?macro=true";
import { default as accountingP_45mdyCZyf8nNNkYtqRSsjtxLoIGo7iINTfMfIbV1irEMeta } from "/builds/weplaybig/platform/big-front/pages/company/accounting.vue?macro=true";
import { default as indexIkTIo8Ilmq8WApOHR7aRkS5Kv4g6NqNpKFHEJEBHq50Meta } from "/builds/weplaybig/platform/big-front/pages/pass-d/create/index.vue?macro=true";
import { default as editu9q9UtRvjvNCy1ElDhs0gkXx0IXVFt_45L6sJx5J458ygMeta } from "/builds/weplaybig/platform/big-front/pages/accounting/[id]/edit.vue?macro=true";
import { default as index_453cKnl69Pa0eHrx_45J58XRbcWkTqzBc2O9OIElmOh9hQMeta } from "/builds/weplaybig/platform/big-front/pages/company/create/index.vue?macro=true";
import { default as leaderboard2QjUTPcaOjrf76I0Pdg7nCtKu_npPSl4JQb92sq3yCQMeta } from "/builds/weplaybig/platform/big-front/pages/referral/leaderboard.vue?macro=true";
import { default as step_451nfQlW6__CecSEWNb37jWNSRnbC3mPrpno6L8KEFCWa8Meta } from "/builds/weplaybig/platform/big-front/pages/subscribe/onboarding/step-1.vue?macro=true";
import { default as step_452glscPbDykCY5EMwWS8lJjpdO0XCvvQiBNcUAHfMfVbUMeta } from "/builds/weplaybig/platform/big-front/pages/subscribe/onboarding/step-2.vue?macro=true";
import { default as step_453cVylTpeMhXvUn9cPJfc_45bx3JvPfhg7imWIqfXxXCzZUMeta } from "/builds/weplaybig/platform/big-front/pages/subscribe/onboarding/step-3.vue?macro=true";
import { default as onboardingkhBBnQPO_453Q2PHlYi7A8U7fiDXGDqOrUcjuOcY54Xt8Meta } from "/builds/weplaybig/platform/big-front/pages/subscribe/onboarding.vue?macro=true";
import { default as indexL0_iQ0CzMXbGIMJlsPUkykPteK2JLUe6vID_uwF4JoAMeta } from "/builds/weplaybig/platform/big-front/pages/accounting/[id]/index.vue?macro=true";
import { default as indexcDtQAit2Bd2RIjrKFFxJeZizgNcRG_45PrU5ul4rPTabMMeta } from "/builds/weplaybig/platform/big-front/pages/company/experts/index.vue?macro=true";
import { default as index_DSEP2Bbc7tT_dVVSKazjhSLS_45R7wF1VZacV45aSPzEMeta } from "/builds/weplaybig/platform/big-front/pages/settings/dialer/index.vue?macro=true";
import { default as address4E6mc_459CUHYCjHQ4xossOQJsIvyiaInUYVJq8Qzy1_450Meta } from "/builds/weplaybig/platform/big-front/pages/company/create/address.vue?macro=true";
import { default as searchyU3KZ7MmLjikIs5npZw0_45_c_uvrWPdYtICYFrEoW6M4Meta } from "/builds/weplaybig/platform/big-front/pages/company/experts/search.vue?macro=true";
import { default as indextlXVVYp8GkzDNsQKUz_45pJFGqYkIu9lZQNGckDcu9C4EMeta } from "/builds/weplaybig/platform/big-front/pages/company/missions/index.vue?macro=true";
import { default as indexby1845tLLZ1SoCzAYqnJiOSBpppICcJi9y_45w7_45QPqkwMeta } from "/builds/weplaybig/platform/big-front/pages/settings/company/index.vue?macro=true";
import { default as _91id_93nNW5sL1bueYJCbnlmlKx5DvADoCf6R552M9kcp_fGyQMeta } from "/builds/weplaybig/platform/big-front/pages/accounting/company/[id].vue?macro=true";
import { default as index9FtCsTTTBYOFkGFniIunyQiUGKGFnH5RDWW60Q3oQ7QMeta } from "/builds/weplaybig/platform/big-front/pages/settings/payments/index.vue?macro=true";
import { default as indexXhwpr4eWIcW4IHiFeKj7LTlegmFDzojDt4d7Cc_45_453ikMeta } from "/builds/weplaybig/platform/big-front/pages/settings/security/index.vue?macro=true";
import { default as indexIe_451xjNV_45bdDQamgw9FSkN1hjHKRcMEvoWlU7TPh6R0Meta } from "/builds/weplaybig/platform/big-front/pages/accounting/company/index.vue?macro=true";
import { default as indexzh5pmsnfwcsMry6FIku1kk8qDPGnt7_vj5C_45ZSKoDMwMeta } from "/builds/weplaybig/platform/big-front/pages/company/onboarding/index.vue?macro=true";
import { default as _91token_9358BBW1y8ytB1O9bKBhSL3A4RuaytYfkCBukTNBSwuOsMeta } from "/builds/weplaybig/platform/big-front/pages/mission-feedback/[token].vue?macro=true";
import { default as indexC7uaSOUxSblEE0DX3KQLH01BSPvJM6zJbH9_45aFOLLhIMeta } from "/builds/weplaybig/platform/big-front/pages/settings/languages/index.vue?macro=true";
import { default as companyn59PDKuODuxX0ZZc_45_45gmOuB9_45jNK_1RViGND1zWhvOUMeta } from "/builds/weplaybig/platform/big-front/pages/company/onboarding/company.vue?macro=true";
import { default as details0eW_45t8R6fUiMDlrxBc2qqmiGWml826arsDe760utVIAMeta } from "/builds/weplaybig/platform/big-front/pages/company/onboarding/details.vue?macro=true";
import { default as indexx2WMLyQaZHhtJSC4VBtW0_45hKv06KxAWOe8YPPfP1ccIMeta } from "/builds/weplaybig/platform/big-front/pages/terms-and-conditions/index.vue?macro=true";
import { default as informationsbG1ifg6yeK_45yH8dGxO7MJW3_45H9czawfqNOE4MBPPlfAMeta } from "/builds/weplaybig/platform/big-front/pages/company/create/informations.vue?macro=true";
import { default as registerof5gTzmnhYifcY0pzhZYymZpdHC5hpCM5W9GFXgIRhIMeta } from "/builds/weplaybig/platform/big-front/pages/company/onboarding/register.vue?macro=true";
import { default as indexNFqPbgZP2ZAvbkom5WSDldGAj7Niz54oh_aS7kCJ66cMeta } from "/builds/weplaybig/platform/big-front/pages/settings/informations/index.vue?macro=true";
import { default as clientnz9W8iScsybLPJ_45ZvEZdN_K2uX4SMxnSGVqkowcJam8Meta } from "/builds/weplaybig/platform/big-front/pages/terms-and-conditions/client.vue?macro=true";
import { default as indexQo4VirHSsWn6RC8vhzn3kKFxD_l_45mOjY6ifmVo0WtTEMeta } from "/builds/weplaybig/platform/big-front/pages/settings/notifications/index.vue?macro=true";
import { default as invitationcRaA_Db3CrL3AvkTR6oEaqsIpt43bM8v_45zkDirun45sMeta } from "/builds/weplaybig/platform/big-front/pages/pass-d/create/[id]/invitation.vue?macro=true";
import { default as freelanceHmqQK49GNFu_45wM0D9DgsVrqZIulILl7R7FuY0E_QkJcMeta } from "/builds/weplaybig/platform/big-front/pages/terms-and-conditions/freelance.vue?macro=true";
import { default as MissionListZuVoa3e07rDGqOKoMbX47zgwEVxwwFH3WwFYsuCKt7EMeta } from "/builds/weplaybig/platform/big-front/pages/missions/local-components/MissionList.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginy5H4Wj0vP9pLe7DRcxRgdAYPUcG5ykwMzSrsQRo2q74Meta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/login.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexkA7_45TYy_45YN_85CWaYf_45pqv5JXCsFWlvZFy_45s6_453SAlUMeta || {}), ...{"middleware":["admin","auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/admin/index.vue")
  },
  {
    name: "pass-d",
    path: "/pass-d",
    meta: {"middleware":["freelance","auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/pass-d/index.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: callbackZuvMkEzCAnpStBv3Z0LyhATX_454hnjyyPxGzgUZ8T2FAMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/auth/callback.vue")
  },
  {
    name: "account-slug",
    path: "/account/:slug()",
    meta: _91slug_93Jjrh8fT8Hq9xtcB0_yEnQZCQ6WOKXo34r_bfAhzNuIwMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/account/[slug].vue")
  },
  {
    name: "missions",
    path: "/missions",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/missions/index.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: {"middleware":["freelance","auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/referral/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/index.vue")
  },
  {
    name: "company-profile",
    path: "/company/profile",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/profile.vue")
  },
  {
    name: "confidentiality",
    path: "/confidentiality",
    meta: { ...(confidentialityIbNe916Feru5m7hSQstU7_Sc76E40HPX08ADyAsXYvUMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/confidentiality.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/dashboard/index.vue")
  },
  {
    name: "password-forgot",
    path: "/password/forgot",
    meta: forgota9zvW7AMKqUF61ouZy_e1ergJn7I8oRNXvBuSWwWmLwMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/password/forgot.vue")
  },
  {
    name: "subscribe",
    path: "/subscribe",
    meta: index12ROdBI2pTC7GqieTnMDBsrm23hZB2H_45iOSy9gRQs_45UMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/subscribe/index.vue")
  },
  {
    name: "accounting",
    path: "/accounting",
    component: () => import("/builds/weplaybig/platform/big-front/pages/accounting/index.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    meta: { ...(mentions_45legalesZL0pDZ8xBVTmxPNN69ODUf5I5d7RcbOXsYiHZkucQCIMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/mentions-legales.vue")
  },
  {
    name: "pass-d-id-edit",
    path: "/pass-d/:id()/edit",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/pass-d/[id]/edit.vue")
  },
  {
    name: "pass-d-id-join",
    path: "/pass-d/:id()/join",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/pass-d/[id]/join.vue")
  },
  {
    name: "password-recover",
    path: "/password/recover",
    meta: recoverWm_veIJxuKg7M_TVNu0dTudKRQjjxkYjmGc74SNCDggMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/password/recover.vue")
  },
  {
    name: "accounting-create",
    path: "/accounting/create",
    component: () => import("/builds/weplaybig/platform/big-front/pages/accounting/create.vue")
  },
  {
    name: "company-accounting",
    path: "/company/accounting",
    meta: {"middleware":["organization","auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/accounting.vue")
  },
  {
    name: "pass-d-create",
    path: "/pass-d/create",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/pass-d/create/index.vue")
  },
  {
    name: "accounting-id-edit",
    path: "/accounting/:id()/edit",
    component: () => import("/builds/weplaybig/platform/big-front/pages/accounting/[id]/edit.vue")
  },
  {
    name: "company-create",
    path: "/company/create",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/create/index.vue")
  },
  {
    name: "referral-leaderboard",
    path: "/referral/leaderboard",
    meta: {"middleware":["freelance","auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/referral/leaderboard.vue")
  },
  {
    name: "subscribe-onboarding",
    path: "/subscribe/onboarding",
    meta: { ...(onboardingkhBBnQPO_453Q2PHlYi7A8U7fiDXGDqOrUcjuOcY54Xt8Meta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/subscribe/onboarding.vue"),
    children: [
  {
    name: "subscribe-onboarding-step-1",
    path: "step-1",
    meta: step_451nfQlW6__CecSEWNb37jWNSRnbC3mPrpno6L8KEFCWa8Meta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/subscribe/onboarding/step-1.vue")
  },
  {
    name: "subscribe-onboarding-step-2",
    path: "step-2",
    meta: step_452glscPbDykCY5EMwWS8lJjpdO0XCvvQiBNcUAHfMfVbUMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/subscribe/onboarding/step-2.vue")
  },
  {
    name: "subscribe-onboarding-step-3",
    path: "step-3",
    component: () => import("/builds/weplaybig/platform/big-front/pages/subscribe/onboarding/step-3.vue")
  }
]
  },
  {
    name: "accounting-id",
    path: "/accounting/:id()",
    component: () => import("/builds/weplaybig/platform/big-front/pages/accounting/[id]/index.vue")
  },
  {
    name: "company-experts",
    path: "/company/experts",
    meta: { ...(indexcDtQAit2Bd2RIjrKFFxJeZizgNcRG_45PrU5ul4rPTabMMeta || {}), ...{"middleware":["organization","auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/experts/index.vue")
  },
  {
    name: "settings-dialer",
    path: "/settings/dialer",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/dialer/index.vue")
  },
  {
    name: "company-create-address",
    path: "/company/create/address",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/create/address.vue")
  },
  {
    name: "company-experts-search",
    path: "/company/experts/search",
    meta: { ...(searchyU3KZ7MmLjikIs5npZw0_45_c_uvrWPdYtICYFrEoW6M4Meta || {}), ...{"middleware":["organization","auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/experts/search.vue")
  },
  {
    name: "company-missions",
    path: "/company/missions",
    meta: {"middleware":["organization","auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/missions/index.vue")
  },
  {
    name: "settings-company",
    path: "/settings/company",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/company/index.vue")
  },
  {
    name: "accounting-company-id",
    path: "/accounting/company/:id()",
    component: () => import("/builds/weplaybig/platform/big-front/pages/accounting/company/[id].vue")
  },
  {
    name: "settings-payments",
    path: "/settings/payments",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/payments/index.vue")
  },
  {
    name: "settings-security",
    path: "/settings/security",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/security/index.vue")
  },
  {
    name: "accounting-company",
    path: "/accounting/company",
    component: () => import("/builds/weplaybig/platform/big-front/pages/accounting/company/index.vue")
  },
  {
    name: "company-onboarding",
    path: "/company/onboarding",
    meta: indexzh5pmsnfwcsMry6FIku1kk8qDPGnt7_vj5C_45ZSKoDMwMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/onboarding/index.vue")
  },
  {
    name: "mission-feedback-token",
    path: "/mission-feedback/:token()",
    component: () => import("/builds/weplaybig/platform/big-front/pages/mission-feedback/[token].vue")
  },
  {
    name: "settings-languages",
    path: "/settings/languages",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/languages/index.vue")
  },
  {
    name: "company-onboarding-company",
    path: "/company/onboarding/company",
    meta: companyn59PDKuODuxX0ZZc_45_45gmOuB9_45jNK_1RViGND1zWhvOUMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/onboarding/company.vue")
  },
  {
    name: "company-onboarding-details",
    path: "/company/onboarding/details",
    meta: details0eW_45t8R6fUiMDlrxBc2qqmiGWml826arsDe760utVIAMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/onboarding/details.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: { ...(indexx2WMLyQaZHhtJSC4VBtW0_45hKv06KxAWOe8YPPfP1ccIMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/terms-and-conditions/index.vue")
  },
  {
    name: "company-create-informations",
    path: "/company/create/informations",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/create/informations.vue")
  },
  {
    name: "company-onboarding-register",
    path: "/company/onboarding/register",
    meta: registerof5gTzmnhYifcY0pzhZYymZpdHC5hpCM5W9GFXgIRhIMeta || {},
    component: () => import("/builds/weplaybig/platform/big-front/pages/company/onboarding/register.vue")
  },
  {
    name: "settings-informations",
    path: "/settings/informations",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/informations/index.vue")
  },
  {
    name: "terms-and-conditions-client",
    path: "/terms-and-conditions/client",
    meta: { ...(clientnz9W8iScsybLPJ_45ZvEZdN_K2uX4SMxnSGVqkowcJam8Meta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/terms-and-conditions/client.vue")
  },
  {
    name: "settings-notifications",
    path: "/settings/notifications",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/settings/notifications/index.vue")
  },
  {
    name: "pass-d-create-id-invitation",
    path: "/pass-d/create/:id()/invitation",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/pass-d/create/[id]/invitation.vue")
  },
  {
    name: "terms-and-conditions-freelance",
    path: "/terms-and-conditions/freelance",
    meta: { ...(freelanceHmqQK49GNFu_45wM0D9DgsVrqZIulILl7R7FuY0E_QkJcMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/builds/weplaybig/platform/big-front/pages/terms-and-conditions/freelance.vue")
  },
  {
    name: "missions-local-components-MissionList",
    path: "/missions/local-components/MissionList",
    meta: {"middleware":["auth","company"]},
    component: () => import("/builds/weplaybig/platform/big-front/pages/missions/local-components/MissionList.vue")
  }
]